import { page, content } from '../pages/index.module.scss';
import React from 'react';
import Layout from './layout';
import NewsletterSubscription from './NewsletterSubscription';
import CardList from './card-list/CardList';
import { useStaticQuery, graphql } from 'gatsby';

interface CardListPageTemplateProps {
  selectedCategorySlug: string | null;
}

const CardListPageTemplate = ({ selectedCategorySlug }: CardListPageTemplateProps) => {
  const {
    wpPage: { content: pageContent },
  } = useStaticQuery(graphql`
    query SEOPageContent {
      wpPage(slug: { eq: "seo" }) {
        content
      }
    }
  `);

  return (
    <Layout>
        <div className={page}>
            <main>
                <div className={content} dangerouslySetInnerHTML={{ __html: pageContent }}></div>
                <CardList selectedCategorySlug={selectedCategorySlug} />
            </main>
        </div>
      <NewsletterSubscription />
    </Layout>
  );
};

export default CardListPageTemplate;